<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <editor :options="options" 
      :id="id" 
      ref="input" 
      v-bind="$attrs" 
      class="form-textarea" 
      :class="{ error: error }" 
      :initialValue="value" 
      @change="onEditorChange"
      initialEditType='wysiwyg'/>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';

import { Editor } from '@toast-ui/vue-editor';

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `editor-input-${this._uid}`
      },
    },
    value: String,
    label: String,
    error: String,
    options: {
      type: Object,
      default(){
        return {
          usageStatistics: false,
          hideModeSwitch: false,
          toolbarItems: [
              ['heading', 'bold', 'italic', 'strike'],
              ['hr', 'ul', 'ol', 'indent', 'outdent'],
              ['table', 'image', 'link'],
              ['code', 'codeblock'],
              ['scrollSync'],
            ]
        }
      }
    }
  },
  components:{
    Editor
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    onEditorChange(val){
      let md = this.$refs.input.invoke('getMarkdown');
      this.$emit('input', md)
    }
  },
}
</script>
